module.exports = __webpack_public_path__ + "img/Group 250.e8125ade.svg";